exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\r\n* Recent Changes\r\n*/\r\n\r\n.recent-changes {\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\r\n}\r\n\r\n.material-icons {\r\n\tvertical-align: middle;\r\n}\r\n\r\ntime {\r\n\tfont-size: .8rem;\r\n\tcolor: #bbb;\r\n}\r\n\r\nbutton {\r\n\tcolor: #3eb049;\r\n}\r\n\r\n.delete-btn {\r\n  color: red;\r\n}\r\n\r\n.close-btn {\r\n  color: #666;\r\n}\r\n\r\n.user-details mat-spinner {\r\n  display: inline;\r\n  position: relative;\r\n  margin: 10px;\r\n}\r\n\r\n::ng-deep .mat-tab-group.mat-primary .mat-ink-bar, \r\n .mat-tab-nav-bar.mat-primary .mat-ink-bar {\r\n  background-color:#3d1951\r\n}\r\n\r\n::ng-deep mat-dialog-content.mat-dialog-content {\r\n  height: auto;\r\n}\r\n\r\n::ng-deep .mat-dialog-content {\r\n  height: 100%;\r\n  max-height: 80vh;\r\n}\r\n\r\n@media screen and (max-height:600px){\r\n  ::ng-deep mat-dialog-content.mat-dialog-content {\r\n    height: 100%;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/users/user-details/user-details.component.css
// module id = ../../../../../src/app/users/user-details/user-details.component.css
// module chunks = main